import { AD_NAME_QUERY_PARAM } from 'root-constants'

export const getAdNameFromSearch = (search: string): string =>
  new URLSearchParams(search).get(AD_NAME_QUERY_PARAM)?.trim().toLowerCase() ??
  ''
